import { Injectable } from '@angular/core';
import { Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class CustomerGuideService extends WebService {

  public getCustomerGuide(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append('_page', String(page));
    } else {
      params.append('_page', '1');
    }

    if (per_page !== null && per_page !== undefined) {
      params.append('_limit', String(per_page));
    } else {
      params.append('_limit', '10');
    }

    if (sort !== null && sort !== undefined) {
      params.append('_sort', String(sort));
    }

    if (query !== null && query !== undefined && query !== '') {
      params.append('_q', String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    params.append('_with', String('company.gestion_sac,profile_survey,requisition,updated_by,customer_guide_justification.user.employee,inactive_by'));

    const options = new RequestOptions({ search: params, headers: this.headers });

    return this.http.get(`${this.apiUrl}/customer-guides?${params}`, options);
  }

  public newCustomerGuide(body: Object): Observable<Response> {
    return this.http.post(`${this.apiUrl}/customer-guides`, JSON.stringify(body), { headers: this.headers });
  }

  public uploadCustomerGuideDocuments(id: number, formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.apiUrl}/customer-guides-documents/${id}`, formData, options);
  }

  public updateCustomerGuide(id: number, body: Object): Observable<Response> {
    return this.http.patch(`${this.apiUrl}/customer-guides/${id}`, JSON.stringify(body), { headers: this.headers });
  }

  public deleteCustomerGuide(id: number): Observable<Response> {
    return this.http.delete(`${this.apiUrl}/customer-guides/${id}`, { headers: this.headers });
  }

  public infoCustomerGuide(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('id', String(id));
    params.append('_sort', String('-customer_guide_justification.created_at'));
    params.append('_with', String('customer_guide_justification.user.employee,company,documents_customer_guide'));

    const options = new RequestOptions({ search: params, headers: this.headers });

    return this.http.get(`${this.apiUrl}/customer-guides/${id}?${params}`, options);
  }
  public infoCustomerGuideCitation(company_id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('company_id', String(company_id));
    params.append('_sort', String('-customer_guide_justification.created_at'));
    params.append('_with', String('customer_guide_justification.user.employee'));

    const options = new RequestOptions({ search: params, headers: this.headers });

    return this.http.get(`${this.apiUrl}/customer-guides/citation?${params}`, options);
  }
  public editFirstDayCustomerGuide(id: number, body: Object): Observable<Response> {
    return this.http.patch(`${this.apiUrl}/customer-guides/first-day/${id}`, JSON.stringify(body), { headers: this.headers });
  }
  public getDocumentsCustomerGuide(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('customer_guide_id', String(id));
    params.append('_sort', String('-id'));

    const options = new RequestOptions({ search: params, headers: this.headers });

    return this.http.get(`${this.apiUrl}/customer-guides/${id}/documents?${params}`, options);
  }
  public copyCustomerGuide(customer_guide_id, business_id): Observable<Response> {
    const request = { customer_guide_id, business_id };
    return this.http.post(`${this.apiUrl}/copy-customer-guide`, JSON.stringify(request), { headers: this.headers });
  }
  public newCustomerGuideSynergo(body: Object): Observable<Response> {
    return this.http.post(`${this.apiUrl}/customer-guides-synergo`, JSON.stringify(body), { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/customer-guide/customer-guide.service.ts